<template>
	<div style="margin: 0 auto;">
		<div style="font-size: 30px; padding: 10px 0;">{{ $route.meta.title }}</div>

		<Table :data="tableData2" :columns="tableColumns2" size="large" border :loading="loading">
			<template slot-scope="{ row }" slot="type">
				<Tag color="primary" v-if="row.type == 'jcz'">检测站</Tag>
				<Tag color="success" v-else-if="row.type == 'mj'">免检</Tag>
				<Tag color="error" v-else-if="row.type == 'dj'">代驾</Tag>
			</template>
			<template slot-scope="{ row }" slot="state">
				<span class="text-green" v-if="row.stateflag == '1'">生效</span>
				<span class="text-grey" v-else-if="row.stateflag == '0'">无效</span>
				<span class="error" v-else>未知</span>
			</template>
			<template slot-scope="{ row }" slot="dj">
				<span class="text-red">{{row.content.money}}</span> 元
			</template>
			<template slot-scope="{ row }" slot="yj">
				<span class="text-red">{{row.content.tc}}</span> 元
			</template>
			<template slot-scope="{ row,index }" slot="action">
					<Button type="primary" @click="showOrderSettingModal(index)">
						设置
						<Icon type="ios-arrow-forward" />
					</Button>
			</template>
		</Table>
		<Modal v-model="orderSettingModal" :title="orderSettingModalTitle" @on-ok="orderSettingSubmit('formOrderSetting')" :mask-closable="false" loading>
			<div style="position: relative;" class="padding-left padding-right-xl">
				<Form ref="formOrderSetting" :model="formOrderSetting" label-position="right" :label-width="100" label-colon>
					<FormItem label="订单类型">
						<span class="text-red" v-if="formOrderSetting.type=='dj'">代驾</span>
						<span class="text-blue" v-if="formOrderSetting.type=='jcz'">检测站</span>
						<span class="text-cyan" v-if="formOrderSetting.type=='mj'">免检</span>
					</FormItem>
					<FormItem label="服务费">
						<Input v-model="formOrderSetting.content.money" maxlength="4" style="width:100px; text-align: right;"></Input> 元
					</FormItem>
					<FormItem label="师傅提成">
						<Input v-model="formOrderSetting.content.tc" maxlength="4" style="width:100px; text-align: right;"></Input> 元
					</FormItem>
					<FormItem label="通知手机">
						<Input v-model="formOrderSetting.content.notifymobile" maxlength="11" style="width:120px; text-align: right;"></Input>
					</FormItem>
					<FormItem label="说明">
						<Input v-model="formOrderSetting.content.intro" type="textarea" :rows="4" placeholder="" maxlength=140 show-word-limit />
					</FormItem>
				</Form>
			</div>
		</Modal>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				tableColumns2: [{
						title: 'id',
						type: 'index',
						width: 58
					},
					{
						title: '类型',
						key: 'type',
						align: 'center',
						slot: 'type'
					},
					{
						title: '状态',
						key: 'stateflag',
						align: 'center',
						slot: 'state'
					},
					{
						title: '定价',
						align: 'center',
						slot: 'dj'
					},
					{
						title: '师傅佣金',
						align: 'center',
						slot: 'yj'
					},
					{
						title: '添加时间',
						key: 'addtime'
					},
					{
						title: '更新时间',
						key: 'updatetime'
					},
					{
						title: '操作',
						slot: 'action'
					}
				],
				tableData2: [],
				orderSettingLoading: false,
				orderSettingModal:false,
				formOrderSetting: {
					type: "",
					content: {
						money: 0,
						tc:0,
						tg:0,
						intro: ""
					}
				},
				orderSettingModalTitle:""
			};
		},
		methods: {
			handleSubmit(name) {
				this.loadinfos();
				return false;
			},
			loadinfos() {
				var that = this;
				this.loading = true;
				this.$http.post('/server/api/order/index.php?a=setting').then(
					res => {
						this.loading = false;
						if (res.data.result == 'ok') {
							//this.$Message.success('获取成功!');
							this.tableData2 = res.data.data.infos;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loading = false;
						this.$Message.error('系统错误');
					}
				);
			},
			showOrderSettingModal(index){
				this.formOrderSetting=this.tableData2[index];
				if(this.formOrderSetting.type=='dj') this.orderSettingModalTitle="代驾订单设置";
				if(this.formOrderSetting.type=='jcz') this.orderSettingModalTitle="检测站订单设置";
				if(this.formOrderSetting.type=='mj') this.orderSettingModalTitle="免检订单设置";
				this.orderSettingModal=true;
			},
			orderSettingSubmit: function(name) {
				this.$Spin.show();
				this.$http.post('/server/api/order/index.php?a=settingup',this.$qs.stringify(this.formOrderSetting)).then(
					res => {
						this.$Spin.hide();
						if (res.data.result == 'ok') {
							this.$Message.success('更新成功!');
							
							this.orderSettingModal=false;
							this.loadinfos();
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.$Spin.hide();
						this.$Message.error('系统错误');
					}
				);
			}
		},
		created() {
			//console.log(this.searchForm)
			this.loadinfos();
		}
	};
</script>

<style>
	.chepai {
		display: inline-block;
		padding: 3px 8px;
		border-radius: 3px;
		background: #0081ff;
		color: #ffffff;
		line-height: 24px;
	}
</style>
